export default __webpack_public_path__ + "static/media/banner.8e1aa5fb.svg";